// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal CSS */

.addEditModal {
    max-width: 25rem !important;
}

.addEditModal-toyota .modal-dialog, .addEditModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.addEditModal-lexus .modal-dialog, .addEditModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.addEditModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.addEditModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.redFont {
    color: #e50000;
}

.addEditModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.addEditModal-lexus .css-10nd86i svg {
    color: #252525;
}

.addEditModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.addEditModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}

.addTmekpi_modal_unit{
    width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd","sourcesContent":["/* Modal CSS */\n\n.addEditModal {\n    max-width: 25rem !important;\n}\n\n.addEditModal-toyota .modal-dialog, .addEditModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.addEditModal-lexus .modal-dialog, .addEditModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.addEditModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.addEditModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.redFont {\n    color: #e50000;\n}\n\n.addEditModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.addEditModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.addEditModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.addEditModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n\n.addTmekpi_modal_unit{\n    width: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
